import { MapPin, MessageCircle, Phone } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function Community({ catalog }) {
  const { t } = useLang();
  const link = catalog?.whatsapp_link;
  return (
    <section id="contact" className="max-w-6xl mx-auto px-5 py-20 sm:py-28 grid lg:grid-cols-2 gap-6">
      <div className="relative overflow-hidden rounded-3xl bg-forest-800 text-parchment p-8 sm:p-10 grain" data-testid="whatsapp-community-card">
        <MessageCircle className="w-10 h-10 text-brass-300" />
        <h2 className="mt-5 text-3xl sm:text-4xl font-semibold">{t("cm.title")}</h2>
        <p className="mt-3 text-parchment/75 text-sm sm:text-base">{t("cm.text")}</p>
        {link ? (
          <a href={link} target="_blank" rel="noopener noreferrer" className="mt-7 inline-flex px-7 py-3.5 rounded-full bg-[#25D366] text-forest-900 font-semibold hover:brightness-110 transition" data-testid="whatsapp-community-link">
            {t("cm.join")}
          </a>
        ) : (
          <span className="mt-7 inline-flex px-7 py-3.5 rounded-full bg-parchment/10 text-parchment/70 text-sm" data-testid="whatsapp-community-link-pending">[Community link coming soon]</span>
        )}
      </div>
      <div className="rounded-3xl overflow-hidden border border-parchment-300 bg-white grid sm:grid-cols-2">
        <img src="/images/yoga.jpg" alt="Meditation practice" className="w-full h-48 sm:h-full object-cover" />
        <div className="p-8 space-y-6">
          <p className="eyebrow">{t("cm.visit")}</p>
          <div className="flex gap-3">
            <MapPin className="w-5 h-5 text-brass-700 shrink-0 mt-0.5" />
            <p className="text-forest-800 text-sm leading-relaxed" data-testid="contact-address">{catalog?.address}</p>
          </div>
          <a href={`tel:+91${catalog?.phone}`} className="flex gap-3 items-center text-forest-800 hover:text-brass-700" data-testid="contact-phone">
            <Phone className="w-5 h-5 text-brass-700" />
            <span className="font-serif text-2xl font-bold">+91 {catalog?.phone}</span>
          </a>
        </div>
      </div>
    </section>
  );
}
